const crmTypeSortKey = id => {
  switch (id) {
    case 3: // Customer
      return 0;
    case 2: // Prospect
      return 1;
    case 4: // Own company
      return 2;
    case 0: // Other
      return 3;
    default:
      // Unknown
      return 9;
  }
};
export const crmTypeSorter = ({ id: a }, { id: b }) => {
  const sortA = crmTypeSortKey(a);
  const sortB = crmTypeSortKey(b);

  return sortA < sortB ? -1 : sortA > sortB;
};

const languagePrio = {
  nl: 1,
  fr: 2,
  en: 3,
};

///Sort languages from datacache
//dataCache.getArray('language').sort(languageSorter);
export const languageSorter = (a, b) => {
  const prioA = languagePrio[a.code] || 9;
  const prioB = languagePrio[b.code] || 9;

  if (prioA < prioB) return -1;
  if (prioA > prioB) return 1;
  return 0;
};
//dataCache.getArray('language').sort(languageSorterCurrentFirst(currentLanguage));
export const languageSorterCurrentFirst = currentLang => {
  const langCode = currentLang.split('-')[0];
  if (!currentLang) return languageSorter;

  return (a, b) => {
    if (a.code === langCode) return -1;
    if (b.code === langCode) return 1;
    return languageSorter(a, b);
  };
};

export default { crmType: crmTypeSorter };
